export default "__VITE_ASSET__CpbbzIQe__"